"use client"

import { useState, useEffect } from "react"
import moment from "moment"
import {
  Dialog,
  DialogTitle,
  DialogContent,MenuItem,
  DialogActions,
  Button,
  TextField,
  Stack,
  Box,
  Typography,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  styled,
  Select,
} from "@mui/material"
import { Close as CloseIcon } from "@mui/icons-material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}))

export default function EditBonusCardDialog({ provider, open, onClose, branches, onSave, card }) {
  
  
  const [formData, setFormData] = useState({
    _id: "",
    status: "enabled",
    maxPoints: 0,
    branchId: null,
    description: "",
    validUntil: null,
    imageFile: null,
  })
  const [imagePreview, setImagePreview] = useState(null)

  useEffect(() => {
    if (card) {
      setFormData({
        _id: card._id,
        status: card.status,
        maxPoints: card.maxPoints,
        branchId: card.branchDetails?._id ?? null,
        description: card.details,
        validUntil: moment.unix(card.validUntil).toDate(),
        imageFile: null,
      })
      setImagePreview(card.image)
    }
  }, [card])

  const handleChange = (e) => {
    console.log(e.target.name, e.target.value);
    
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleFileChange = (e) => {
    if (e.target.files?.[0]) {
      setFormData((prev) => ({
        ...prev,
        imageFile: e.target.files[0],
      }))
      setImagePreview(URL.createObjectURL(e.target.files[0]))
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSave(formData)
  }


  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6">Edit Bonus Card</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack spacing={3}>
            <FormControl>
              <FormLabel>Status</FormLabel>
              <RadioGroup row name="status" value={formData.status} onChange={handleChange}>
                <FormControlLabel value="enabled" control={<Radio />} label="Enabled" />
                <FormControlLabel value="disabled" control={<Radio />} label="Disabled" />
              </RadioGroup>
            </FormControl>

            <FormControl fullWidth>
              <FormLabel>Branch</FormLabel>
              <Select
                name="branchId"
                value={formData.branchId}
                onChange={handleChange}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Branch
                </MenuItem>
                {branches?.map((branch) => (
                  <MenuItem key={branch.branchId} value={branch.branchId}>
                    {branch.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Max Points"
              name="maxPoints"
              type="number"
              value={formData.maxPoints}
              onChange={handleChange}
              fullWidth
              required
            />

            <TextField
              label="Description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              multiline
              rows={4}
              fullWidth
            />

            <DatePicker
              label="Valid Until"
              value={formData.validUntil}
              onChange={(newValue) => setFormData((prev) => ({ ...prev, validUntil: newValue }))}
              slotProps={{
                textField: {
                  fullWidth: true,
                },
              }}
            />

            <Box>
              <Typography variant="subtitle2" gutterBottom>
                Card Image
              </Typography>
              <Button variant="outlined" component="label">
                Choose File
                <input type="file" hidden onChange={handleFileChange} accept="image/*" />
              </Button>
              {imagePreview && (
                <Box mt={2}>
                  <img
                    src={imagePreview || "/placeholder.svg"}
                    alt="Card preview"
                    style={{ maxWidth: "100%", maxHeight: "200px" }}
                  />
                </Box>
              )}
            </Box>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            Update Card
          </Button>
        </DialogActions>
      </form>
    </StyledDialog>
  )
}

